export const animeWorks = [
  {
    id: "work-1",
    title: "葬送的芙莉莲",
    type: "TV动画",
    genres: ["奇幻", "冒险", "剧情"],
    region: "日本",
    year: 2023,
    score: 9.4,
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20stylized%20anime%20poster%20of%20a%20silver%20haired%20elf%20mage%20girl%20holding%20a%20wooden%20staff%20in%20a%20flower%20field%20under%20soft%20sunset%20light%2C%20painterly%20fantasy%20style%2C%20clean%20background%2C%20no%20text&width=600&height=800&seq=work-cover-01&orientation=portrait",
    author: "监修：原作者山田钟人",
    studio: "Madhouse",
    status: "已完结",
    episodeCount: "全 28 话",
    synopsis:
      "勇者一行讨伐魔王后，精灵魔法使芙莉莲独自踏上漫长的旅程。在漫长岁月里，她重新理解了「人类的一生」与「告别」的意义，并与新的伙伴一同向北前行。",
    highlights: [
      "以「时间尺度」为切入点的独特叙事结构",
      "魔法特效与背景美术高度统一，画面富层次感",
      "配乐克制而动人，情绪推进自然",
    ],
    reviews: [
      { user: "星野旅人", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20soft%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-01&orientation=squarish", rating: 5, comment: "节奏慢但不拖沓，每一集都像在读一首诗。" },
      { user: "北海的涟漪", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20warm%20orange%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-02&orientation=squarish", rating: 5, comment: "战斗作画和日常氛围兼顾，制作水准非常高。" },
    ],
  },
  {
    id: "work-2",
    title: "咒术回战",
    type: "TV动画",
    genres: ["动作", "奇幻", "黑暗"],
    region: "日本",
    year: 2020,
    score: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=Bold%20stylized%20anime%20poster%20of%20a%20high%20school%20boy%20with%20glowing%20cursed%20energy%20around%20his%20fists%20in%20a%20dark%20city%20alley%2C%20dynamic%20red%20and%20black%20tones%2C%20inked%20action%20style%2C%20no%20text&width=600&height=800&seq=work-cover-02&orientation=portrait",
    author: "原作：芥见下下",
    studio: "MAPPA",
    status: "连载中",
    episodeCount: "已播 47 话",
    synopsis:
      "高中生虎杖悠仁吞下了特级咒物「两面宿傩的手指」，从此被卷入咒术师与咒灵的战斗。他进入东京咒术高专，与同伴一同对抗潜藏在日常中的诅咒。",
    highlights: ["高速战斗演出与大场面调度", "角色群像鲜明，成长线清晰", "咒术设定体系完整，信息量充足"],
    reviews: [
      { user: "祓除者", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20deep%20red%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-03&orientation=squarish", rating: 5, comment: "战斗分镜太顶了，作画回一集比一集强。" },
      { user: "东京的雨", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20cool%20teal%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-04&orientation=squarish", rating: 4, comment: "剧情节奏偶尔偏快，但整体观感很爽。" },
    ],
  },
  {
    id: "work-3",
    title: "间谍过家家",
    type: "TV动画",
    genres: ["喜剧", "动作", "日常"],
    region: "日本",
    year: 2022,
    score: 9.0,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20stylized%20anime%20poster%20of%20a%20stylish%20family%20of%20three%20with%20a%20pink%20haired%20child%20in%20the%20center%2C%20pastel%20pink%20and%20mint%20palette%2C%20clean%20cheerful%20composition%2C%20no%20text&width=600&height=800&seq=work-cover-03&orientation=portrait",
    author: "原作：远藤达哉",
    studio: "WIT STUDIO × CloverWorks",
    status: "连载中",
    episodeCount: "已播 37 话",
    synopsis:
      "间谍「黄昏」为了执行任务，被迫组建一个临时家庭。然而他的「妻子」是杀手、「女儿」是超能力者，三人各怀秘密，却在一连串鸡飞狗跳的日常中逐渐成为真正的家人。",
    highlights: ["家庭喜剧与谍战元素完美融合", "阿尼亚的表情包式演出极具传播力", "色彩明快，适合全家观看"],
    reviews: [
      { user: "花生酱", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20pastel%20pink%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-05&orientation=squarish", rating: 5, comment: "阿尼亚太可爱了，日常回看得全程姨母笑。" },
      { user: "夜帷", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20soft%20mint%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-06&orientation=squarish", rating: 5, comment: "节奏舒服，笑点和动作戏都拿捏得刚好。" },
    ],
  },
  {
    id: "work-4",
    title: "鬼灭之刃",
    type: "TV动画",
    genres: ["动作", "奇幻", "热血"],
    region: "日本",
    year: 2019,
    score: 9.1,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20stylized%20anime%20poster%20of%20a%20young%20swordsman%20in%20a%20checkered%20haori%20with%20flaming%20water%20effects%20swirling%20around%20his%20blade%2C%20deep%20blue%20and%20orange%20contrast%2C%20no%20text&width=600&height=800&seq=work-cover-04&orientation=portrait",
    author: "原作：吾峠呼世晴",
    studio: "ufotable",
    status: "连载中",
    episodeCount: "已播 55 话",
    synopsis:
      "家人惨遭鬼杀害、妹妹祢豆子也变成鬼之后，灶门炭治郎为了寻找让妹妹恢复成人、并讨伐仇敌的方法，加入了鬼杀队，踏上斩鬼之路。",
    highlights: ["ufotable 顶级作画与光影演出", "呼吸法招式视觉化极具冲击力", "情感表达强烈，催泪与热血并存"],
    reviews: [
      { user: "日轮刀", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20deep%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-07&orientation=squarish", rating: 5, comment: "作画天花板，随便截一帧都能当壁纸。" },
      { user: "灶门", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20warm%20amber%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-08&orientation=squarish", rating: 5, comment: "炭治郎的温柔是我追下去的最大动力。" },
    ],
  },
  {
    id: "work-5",
    title: "链锯人",
    type: "TV动画",
    genres: ["动作", "黑暗", "奇幻"],
    region: "日本",
    year: 2022,
    score: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20stylized%20anime%20poster%20of%20a%20young%20man%20with%20a%20chainsaw%20blade%20emerging%20from%20his%20arm%20in%20a%20rainy%20dark%20city%2C%20harsh%20red%20and%20charcoal%20tones%2C%20inked%20style%2C%20no%20text&width=600&height=800&seq=work-cover-05&orientation=portrait",
    author: "原作：藤本树",
    studio: "MAPPA",
    status: "已完结（第一季）",
    episodeCount: "全 12 话",
    synopsis:
      "背负巨额债务的少年电次与链锯恶魔波奇塔签订契约，成为能够化身链锯人的恶魔猎人，在一个残酷而荒诞的世界里挣扎求生。",
    highlights: ["电影感十足的镜头语言", "黑色幽默与暴力美学并存", "配乐与音效设计极具辨识度"],
    reviews: [
      { user: "恶魔猎人", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20charcoal%20gray%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-09&orientation=squarish", rating: 5, comment: "氛围营造一流，像在看一部青年向电影。" },
      { user: "波奇塔", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20crimson%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-10&orientation=squarish", rating: 4, comment: "叙事偏碎片化，但风格化表达很对味。" },
    ],
  },
  {
    id: "work-6",
    title: "孤独摇滚！",
    type: "TV动画",
    genres: ["音乐", "日常", "喜剧"],
    region: "日本",
    year: 2022,
    score: 9.2,
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20stylized%20anime%20poster%20of%20a%20shy%20pink%20haired%20girl%20holding%20an%20electric%20guitar%20with%20colorful%20stage%20lights%20behind%20her%2C%20energetic%20youthful%20palette%2C%20no%20text&width=600&height=800&seq=work-cover-06&orientation=portrait",
    author: "原作：滨路晶",
    studio: "CloverWorks",
    status: "已完结",
    episodeCount: "全 12 话",
    synopsis:
      "极度社恐的少女后藤一里在机缘巧合下加入乐队「结束乐队」，从躲在壁橱里练琴到站上舞台，她一点点克服自己的恐惧，也收获了真正的伙伴。",
    highlights: ["夸张而充满想象力的演出手法", "音乐演出段落质量极高", "对社恐心理的刻画真实又可爱"],
    reviews: [
      { user: "小孤独", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20vivid%20pink%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-11&orientation=squarish", rating: 5, comment: "演出玩得太花了，每一集都能笑出声。" },
      { user: "结束乐队", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20bright%20yellow%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-12&orientation=squarish", rating: 5, comment: "歌好听，情绪也细腻，看完想学吉他。" },
    ],
  },
  {
    id: "work-7",
    title: "我推的孩子",
    type: "TV动画",
    genres: ["剧情", "悬疑", "偶像"],
    region: "日本",
    year: 2023,
    score: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20stylized%20anime%20poster%20of%20a%20young%20idol%20girl%20under%20a%20bright%20spotlight%20with%20neon%20pink%20and%20violet%20stage%20glow%2C%20dramatic%20showbiz%20aesthetic%2C%20no%20text&width=600&height=800&seq=work-cover-07&orientation=portrait",
    author: "原作：赤坂明 × 横枪萌果",
    studio: "动画工房",
    status: "连载中",
    episodeCount: "已播 24 话",
    synopsis:
      "医生五郎转生成为偶像爱之子阿奎亚，带着前世的记忆进入演艺圈。他一边追寻母亲死亡的真相，一边在光鲜亮丽的娱乐圈中摸索前行。",
    highlights: ["对娱乐圈生态的刻画犀利", "舞台演出与情感爆发兼具", "剧情转折意外又合理"],
    reviews: [
      { user: "舞台灯下", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20violet%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-13&orientation=squarish", rating: 5, comment: "开篇即震撼，后续的剧情推进也很稳。" },
      { user: "推し", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20neon%20magenta%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-14&orientation=squarish", rating: 4, comment: "人设和演出都很精致，值得一追。" },
    ],
  },
  {
    id: "work-8",
    title: "药师少女的独语",
    type: "TV动画",
    genres: ["剧情", "悬疑", "历史"],
    region: "日本",
    year: 2023,
    score: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20anime%20poster%20of%20a%20young%20apothecary%20girl%20in%20traditional%20chinese%20dress%20surrounded%20by%20herbs%20and%20glass%20bottles%2C%20refined%20red%20and%20gold%20palette%2C%20no%20text&width=600&height=800&seq=work-cover-08&orientation=portrait",
    author: "原作：日向夏",
    studio: "TOHO animation STUDIO × OLM",
    status: "连载中",
    episodeCount: "已播 24 话",
    synopsis:
      "精通药理的少女猫猫被人贩子卖入后宫，凭借过人的知识与观察力，她破解了一桩桩看似寻常却暗藏玄机的谜题，也逐渐卷入宫廷的暗流之中。",
    highlights: ["药学知识驱动的推理桥段新颖", "后宫美术考据细致、配色典雅", "主角冷静聪慧，人设讨喜"],
    reviews: [
      { user: "猫猫", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20deep%20maroon%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-15&orientation=squarish", rating: 5, comment: "推理和解谜的部分很有意思，看得很上头。" },
      { user: "后宫日记", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20golden%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-16&orientation=squarish", rating: 4, comment: "美术太美了，节奏虽慢但很耐看。" },
    ],
  },
  {
    id: "work-9",
    title: "进击的巨人",
    type: "TV动画",
    genres: ["动作", "剧情", "奇幻"],
    region: "日本",
    year: 2013,
    score: 9.5,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20stylized%20anime%20poster%20of%20a%20determined%20young%20soldier%20standing%20before%20a%20colossal%20stone%20wall%20with%20warm%20dusk%20light%2C%20dramatic%20painterly%20style%2C%20no%20text&width=600&height=800&seq=work-cover-09&orientation=portrait",
    author: "原作：谏山创",
    studio: "WIT STUDIO / MAPPA",
    status: "完结",
    episodeCount: "全 87 话",
    synopsis:
      "在巨人横行的世界里，人类躲在高墙之内苟延残喘。少年艾伦目睹母亲被巨人吞食后，立志驱逐所有巨人，却在追寻真相的过程中，发现了远比巨人更残酷的现实。",
    highlights: ["世界观层层反转，格局宏大", "战斗场面调度震撼，配乐经典", "对自由与牺牲的探讨极具深度"],
    reviews: [
      { user: "调查兵团", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20olive%20green%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-17&orientation=squarish", rating: 5, comment: "从第一集到最终话，情绪一直被牢牢抓住。" },
      { user: "自由之翼", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20steel%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-18&orientation=squarish", rating: 5, comment: "叙事野心极大，值得反复回味。" },
    ],
  },
  {
    id: "work-10",
    title: "命运石之门",
    type: "TV动画",
    genres: ["科幻", "悬疑", "剧情"],
    region: "日本",
    year: 2011,
    score: 9.3,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20stylized%20anime%20poster%20of%20a%20cluttered%20laboratory%20with%20glowing%20green%20monitors%20and%20a%20single%20figure%20silhouette%2C%20moody%20sci%20fi%20atmosphere%2C%20no%20text&width=600&height=800&seq=work-cover-10&orientation=portrait",
    author: "原作：5pb. / Nitroplus",
    studio: "WHITE FOX",
    status: "完结",
    episodeCount: "全 24 话",
    synopsis:
      "自称疯狂科学家的冈部伦太郎意外发明了能向过去发送讯息的「电话微波炉」。当他一次次试图改变过去时，却发现自己正一步步走向无法挽回的深渊。",
    highlights: ["时间旅行设定自洽且精巧", "前期铺垫后期爆发，后劲极强", "角色塑造立体，情感冲击力大"],
    reviews: [
      { user: "El Psy", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20emerald%20green%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-19&orientation=squarish", rating: 5, comment: "熬过前半段，后半段的震撼无法形容。" },
      { user: "世界线", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20cyan%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-20&orientation=squarish", rating: 5, comment: "逻辑闭环做得太好了，科幻迷必看。" },
    ],
  },
  {
    id: "work-11",
    title: "你的名字。",
    type: "剧场版",
    genres: ["爱情", "奇幻", "剧情"],
    region: "日本",
    year: 2016,
    score: 9.2,
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20stylized%20anime%20poster%20of%20two%20teenagers%20standing%20under%20a%20vast%20twilight%20sky%20with%20a%20glowing%20comet%2C%20deep%20blue%20and%20warm%20orange%20gradient%2C%20painterly%20style%2C%20no%20text&width=600&height=800&seq=work-cover-11&orientation=portrait",
    author: "导演：新海诚",
    studio: "CoMix Wave Films",
    status: "已上映",
    episodeCount: "剧场版 · 106 分钟",
    synopsis:
      "住在山间小镇的少女三叶与东京少年泷，在梦中交换了身体。当两人试图寻找彼此，却发现了横亘在他们之间的，是时间与距离都无法轻易跨越的命运。",
    highlights: ["画面每一帧都美到可以截图收藏", "RADWIMPS 配乐与剧情高度契合", "情感线与科幻设定结合自然"],
    reviews: [
      { user: "彗星", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20twilight%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-21&orientation=squarish", rating: 5, comment: "第一次在影院看哭的动画电影。" },
      { user: "黄昏之时", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20sunset%20orange%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-22&orientation=squarish", rating: 5, comment: "配乐一响，情绪立刻被拉满。" },
    ],
  },
  {
    id: "work-12",
    title: "天气之子",
    type: "剧场版",
    genres: ["爱情", "奇幻", "剧情"],
    region: "日本",
    year: 2019,
    score: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20stylized%20anime%20poster%20of%20a%20girl%20praying%20above%20a%20rainy%20tokyo%20skyline%20with%20breaks%20of%20golden%20sunlight%2C%20cool%20blue%20and%20amber%20contrast%2C%20painterly%20style%2C%20no%20text&width=600&height=800&seq=work-cover-12&orientation=portrait",
    author: "导演：新海诚",
    studio: "CoMix Wave Films",
    status: "已上映",
    episodeCount: "剧场版 · 112 分钟",
    synopsis:
      "离家出走的少年帆高来到连日阴雨的东京，遇见了能让天空放晴的少女阳菜。两人在都市的缝隙中相依为命，却也面临着一个艰难的抉择。",
    highlights: ["雨景与光影演出极具表现力", "对都市孤独感的描写真实动人", "配乐与画面依旧保持高水准"],
    reviews: [
      { user: "晴天娃娃", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20sky%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-23&orientation=squarish", rating: 4, comment: "画面和音乐满分，故事稍微有点任性。" },
      { user: "东京雨", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20rain%20gray%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-24&orientation=squarish", rating: 4, comment: "诚哥的雨真的会下雨。" },
    ],
  },
  {
    id: "work-13",
    title: "时光代理人",
    type: "TV动画",
    genres: ["科幻", "悬疑", "剧情"],
    region: "国产",
    year: 2021,
    score: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20stylized%20anime%20poster%20of%20two%20young%20men%20standing%20in%20a%20rainy%20city%20street%20with%20warm%20shop%20lights%2C%20cool%20teal%20and%20amber%20tones%2C%20cinematic%20style%2C%20no%20text&width=600&height=800&seq=work-cover-13&orientation=portrait",
    author: "导演：李豪凌",
    studio: "澜映画 / 哔哩哔哩",
    status: "连载中",
    episodeCount: "已播 23 话",
    synopsis:
      "经营着「时光照相馆」的程小时与陆光，可以进入照片中的世界，替委托人完成未了的心愿。然而规则一旦被打破，时间的涟漪便可能引发难以预料的后果。",
    highlights: ["单元剧结构紧凑，悬念抓人", "对都市情感的刻画细腻", "国产原创动画的代表作之一"],
    reviews: [
      { user: "照相馆", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20teal%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-25&orientation=squarish", rating: 5, comment: "国产原创的惊喜之作，叙事很有想法。" },
      { user: "涟漪", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20amber%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-26&orientation=squarish", rating: 4, comment: "节奏快、反转多，追起来很过瘾。" },
    ],
  },
  {
    id: "work-14",
    title: "大鱼海棠",
    type: "剧场版",
    genres: ["奇幻", "爱情", "剧情"],
    region: "国产",
    year: 2016,
    score: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Ethereal%20stylized%20anime%20poster%20of%20a%20young%20girl%20gazing%20at%20a%20giant%20glowing%20red%20fish%20in%20a%20mystical%20sea%2C%20deep%20red%20and%20teal%20palette%2C%20dreamlike%20painterly%20style%2C%20no%20text&width=600&height=800&seq=work-cover-14&orientation=portrait",
    author: "导演：梁旋 / 张春",
    studio: "彼岸天文化",
    status: "已上映",
    episodeCount: "剧场版 · 105 分钟",
    synopsis:
      "掌管人间海棠生长的少女椿，为报恩而将人类少年鲲的灵魂养在一条小鱼体内。然而这份跨越界限的情感，却为整个族群带来了灾难。",
    highlights: ["东方奇幻美术风格独特", "世界观意象宏大，想象丰富", "色彩与场景设计极具辨识度"],
    reviews: [
      { user: "海棠", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20crimson%20teal%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-27&orientation=squarish", rating: 4, comment: "美术是真的美，故事见仁见智。" },
      { user: "鲲", avatar: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20illustration%20with%20ocean%20blue%20gradient%20and%20simple%20geometric%20shapes%2C%20clean%20modern%20profile%20icon%20style%2C%20no%20text&width=120&height=120&seq=avatar-28&orientation=squarish", rating: 4, comment: "画面想象力拉满，值得一看。" },
    ],
  },
];